module.exports = __webpack_public_path__ + "img/jiulei.ff6cc5aa.png";